<template>
  <v-main>
    <v-container grid-list-md fluid fill-height>
      <v-layout justify-center>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("Welcome")}}</h1>
          <p class="textsize-svs">{{$t("Please use the upper left menu")}}.</p>
          <p class="textsize-svs">{{$t("For more information please visit")}} <a href="http://www.scanvaegt.dk">Scanvaegt Systems</a>.</p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style>
</style>
